// @flow
import React from 'react'
import styled, { css } from 'styled-components'
import { fontSize, spacing } from 'frontend_core/dist/styles/variables'
import { mediaMin } from 'frontend_core/dist/styles/media'
import Colors from 'components/styles/colors'

export type PropTypes = {
  prevPoint?: ?string,
  nextPoint: string,
}

const GetPointPlan = styled.div`
  border: 1px solid ${Colors.grayE};
  padding: 9px 18px 11px;
  font-size: ${fontSize.small_2}px;
  margin-top: 20px;
  text-align: center;
  line-height: 1.4;
  ${mediaMin.phone`
    text-align: center;
  `};
`
const GetPointPlanBr = styled.br`
  ${mediaMin.phone`
    display: none;
  `};
`
const GetPointPlanCancel = styled.span`
  color: ${Colors.grayB};
  text-decoration: line-through;
`
const GetPoint = styled.em`
  font-weight: bold;
`

export default function ReservationGetPointBlock(props: PropTypes) {
  return (
    <GetPointPlan>
      {i18n.t('page.dashboard.reservation.thisSpaceUse')}
      <GetPointPlanBr />
      {props.prevPoint && (
        <GetPointPlanCancel>{props.prevPoint}</GetPointPlanCancel>
      )}
      <GetPoint>
        {props.nextPoint}
        {i18n.t('page.dashboard.reservation.point')}
      </GetPoint>
      {i18n.t('page.dashboard.reservation.acquisitionPlan')}
    </GetPointPlan>
  )
}



// WEBPACK FOOTER //
// ./src/components/molecules/ReservationGetPointBlock/index.jsx